import { ApplicationRemovalTaskStatus } from "./application-removal-task-status";

export class ApplicationRemovalTaskListItem {
  readonly id: string;
  readonly status: ApplicationRemovalTaskStatus;
  readonly scheduledRemoveUnixtime: number;
  readonly procedureName: string;
  readonly targetApplicationsCount: number;
  readonly groupId: string;

  constructor(
    id: string,
    status: ApplicationRemovalTaskStatus,
    scheduledRemoveUnixtime: number,
    procedureName: string,
    targetApplicationsCount: number,
    groupId: string,
  ) {
    this.id = id;
    this.status = status;
    this.scheduledRemoveUnixtime = scheduledRemoveUnixtime;
    this.procedureName = procedureName;
    this.targetApplicationsCount = targetApplicationsCount;
    this.groupId = groupId;
  }

  static fromJSON(
    json: ApplicationRemovalTaskListItem,
  ): ApplicationRemovalTaskListItem {
    return new ApplicationRemovalTaskListItem(
      json.id,
      json.status,
      json.scheduledRemoveUnixtime,
      json.procedureName,
      json.targetApplicationsCount,
      json.groupId,
    );
  }

  static fromJSONArray(
    json: ApplicationRemovalTaskListItem[],
  ): ApplicationRemovalTaskListItem[] {
    if (!json) {
      return [];
    }
    return json.map(ApplicationRemovalTaskListItem.fromJSON);
  }
}
